Librarian.SubscribeWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onSaveClicked", "allowRecipients", "isExternal"],

    options: {
        id: "SubscribeWindow",
        width: 420,
        height: 400,
        data: null,
        recipientType: null // ContactType. Defaults to current user only.
    },

    onComplete: null,
    data: null,

    digestMode: 0,

    selectedContacts: [],

    initialize: function(options) {
        if (!options.data)
            throw "No 'data' provided to SubscribeWindow";

        if (options.onComplete) {
            this.onComplete = options.onComplete;
            options.onComplete = null;
        }

        this.data = Librarian.Utils.getStandardContent(options.data);
        options.data = null;

        this.setOptions(options);

        this.options.title = Librarian.Lang.getString("subscribe_title");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/subscribe.html";

        if (this.allowRecipients())
            this.options.height += 85;

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        if (this.allowRecipients())
            this.setUpRecipients();

        var itemEl = this.getElement("saveButton");
        if (itemEl)
            itemEl.addOnClick(this.onSaveClicked);

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        var subjectCont = this.getElement("subjectCont"),
            messageCont = this.getElement("messageCont"),
            data = this.data;

        Librarian.Utils.setElementValue(this.getElement("contentName"), data.filename || data.groupname || data.name);
        Librarian.Utils.setElementValue(this.getElement("subscriptionSubject"), Librarian.subscriptions.defaultSubject || '');
        Librarian.Utils.setElementValue(this.getElement("subscriptionMessage"), Librarian.subscriptions.defaultMessage || '');

        var notifyEl = this.getElement("notifyWrapper"),
            subfoldersEl = this.getElement("subfoldersWrapper");
        if (notifyEl && subfoldersEl && data.contenttype == Librarian.contentType.category) {
            // Folders can only notify on updates for now
            notifyEl.hide();

            subfoldersEl.show();
        }

        var mode = this.digestMode = Librarian.digestMode,
            external = this.isExternal();

        // Hide subject and message for digests
        if ((external && (mode & 2)) || (!external && (mode & 1))) {
            subjectCont.hide();
            messageCont.hide();

            this.options.height -= 280;
            this.resize();
        }
    },

    allowRecipients: function() {
        return this.options.recipientType > 0;
    },

    isExternal: function() {
        return this.options.recipientType == Librarian.Contacts.contactTypes.contact;
    },

    setUpRecipients: function () {
        var wrapperEl = this.getElement("toBoxWrapper");
        if (wrapperEl)
            wrapperEl.show();

        var toBoxEl = this.getElement("toBox");
        if (!toBoxEl)
            return;

        var self = this,
            url = Librarian.path.getContactUrl("getconts") + "&out=dgrid&perpage=7&orderby=" + encodeURIComponent("firstname,lastname,name,activeemail");

        if (this.options.recipientType == Librarian.Contacts.contactTypes.user)
            url = Librarian.path.getContactUrl("getusers") + "&out=dgrid&perpage=7&all=true&orderby=" + encodeURIComponent("firstname,lastname,email");

        this.recipientSelect = new MooSelect.Remote(toBoxEl, {
            url: url,
            minSearchLength: 1,
            messages: {
                minSearch: Librarian.Lang.getString("deeplink_contact_search")
            },
            remoteOptions: {
                dataPrepareFn: function(term) {
                    return { name: term + '%' };
                },
                requestResponseHandler: function(response) {
                    var data = response.data;

                    data.forEach(function(contact) {
                        contact.text = contact.displayname;

                        if (contact.contactid && contact.contacttype)
                            contact.value = contact.contactid + '-' + contact.contacttype;
                        else
                            contact.value = contact.id || contact.email;
                    });

                    return data;
                }
            },
            allowOtherResult: false,
            onChange: function() {
                self.selectedContacts = this.getStage().getResultData();
            },
            resizeContainerBasedOnInput: false,
            className: "container toBoxSelect",
            defaultWidth: 373,
            searchOnValue: true,
            customBuildStageResultHTML: Librarian.Contacts.renderContactSelectResult,
            customBuildResultHTML: Librarian.Contacts.renderContactSelectOption
        });
    },

    onSaveClicked: function() {
        var buttonEl = this.getElement("saveButton");
        Librarian.Utils.setButtonDisabled(buttonEl, true);

        // Build JSON object
        var subscription = {
            subject: (Librarian.Utils.getElementValue(this.getElement("subscriptionSubject")) || '').trim(),
            message: (Librarian.Utils.getElementValue(this.getElement("subscriptionMessage")) || '').trim(),
            subscriptionType: Librarian.Utils.getElementValue(this.getElement("subscriptionType"))
        };

        if (subscription.message.length > 2000) {
            Librarian.Utils.error(Librarian.Lang.getArgString("required_field_toolong", ["Message", "2,000"]));
            Librarian.Utils.setButtonDisabled(buttonEl, false);
            return;
        }

        subscription.contentId = this.data.contentid;
        subscription.contentType = this.data.contenttype;

        var itemEl = this.getElement("includeSubfolders");
        if (itemEl && subscription.contentType == Librarian.contentType.category)
            subscription.recursive = itemEl.checked;
    
        if (this.allowRecipients() && !this.selectedContacts.length) {
            Librarian.Utils.error(Librarian.Lang.getString("event_nocontacts"));
            return;
        }

        var mode = this.isExternal() ? "external" : "internal";

        var digest = "nonDigest";
        if (this.digestMode & Librarian.subscriptionDigestFlags[mode])
            digest = "digest";

        var subType = subscription.subscriptionType;
        if (digest == "digest" && (this.digestMode & Librarian.subscriptionDigestFlags.combinedDigest))
            subType = Librarian.subscriptionType.combinedDigest;

        var flags = Librarian.subscriptionFlags[mode] | Librarian.subscriptionFlags[digest];

        // Auto-select template ID based on selected subscription type
        var self = this,
            onComplete = function (file) {
                if (file)
                    subscription.templateId = file.supportFileId;
                else
                    subscription.templateId = -1;

                if (self.allowRecipients()) {
                    self.selectedContacts.forEach(function(contact) {
                        subscription.contactid = contact.contactid;
                        subscription.contacttype = contact.contacttype;

                        self.save(subscription);
                    });
                }
                else
                    self.save(subscription);
            },
            supportRequest = new Librarian.Request.JSON({
                url: Librarian.path.getSupportUrl("getfi") + "&ftype=" + Librarian.supportFileType.subscriptionNotification + "&subtype=" + subType + "&type=" + flags + "&tmpl=1&out=cjson",
                onComplete: onComplete
            });
        supportRequest.send();
    },

    save: function(subscription) {
        subscription = JSON.stringify(subscription);
        if (typeof Base64 == "object")
            subscription = Base64.encode(subscription);

        var self = this,
            saveRequest = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("addcs") + "&in=cjson&out=cjson",
                method: "POST",
                data: subscription,
                onSuccess: function(data) {
                    Librarian.Utils.notification(Librarian.Lang.getString("subscribed"), false);

                    if (typeof self.onComplete == "function")
                        self.onComplete(data);
                    self.close();
                },
                onFailure: Librarian.Utils.onFailure
            });
        saveRequest.send();
    }
});